import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import {
    Box,
    Typography,
    Card,
    Tabs,
    Tab,
    IconButton,
    Pagination,
} from '@mui/material';

import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

import { fetchEvents } from 'api/calendar';

import MeetingsCard from "components/MeetingsCard";


const UpcomingItemsComponent = () => {
    const ITEMS = 3;
    const token = useSelector((state) => state.auth.token);
    const currentWorkspaces = useSelector((state) => state.auth.user?.currentWorkspaces);
    const [eventsList, setEventsList] = useState([]);
    const [meetingsList, setMeetingsList] = useState([]);
    const [missingScopesList, setMissingScopesList] = useState([]);
    const [recentValue, setRecentValue] = useState('all');
    const [currentIndex, setCurrentIndex] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [currList, setCurrList] = useState([]);
    const [totalPages, setTotalPages] = useState(Math.ceil(currList.length / ITEMS));

    const handleChange = (event, newValue) => {
        setRecentValue(newValue);
        setCurrentIndex(0); // Reset current index
        setCurrentPage(1); // Reset current page
        setTotalPages(0); // Reset total pages
        setCurrList([]); // reset curr list

        switch (newValue) {
            case 'all':
                setCurrList([...eventsList, ...meetingsList]);
                setTotalPages(Math.ceil([...eventsList, ...meetingsList].length / ITEMS));
                break;
            case 'meetings':
                setCurrList(meetingsList);
                setTotalPages(Math.ceil(meetingsList.length / ITEMS));
                break;
            case 'events':
                setCurrList(eventsList);
                setTotalPages(Math.ceil(eventsList.length / ITEMS));
                break;
        }
    };

    useEffect(() => {
        // reset state variables
        setCurrList([]);
        setEventsList([]);
        setMeetingsList([]);
        setMissingScopesList([]);

        const getRecents = async () => {
            const today = (new Date()).toISOString();
            const maxResults = 10;
            const { events, missingScopes } = await fetchEvents(token, {
                startTime: today,
                maxResults,
                includeAllDay: false,
                sorted: true,
            });

            const meetingsArr = [];
            const eventsArr = [];
            events?.forEach((event) => {
                if (!event.attendees) eventsArr.push(event);
                else event.attendees?.length <= 1 ? eventsArr.push(event) : meetingsArr.push(event);
            });

            setEventsList(eventsArr);
            setMeetingsList(meetingsArr);
            setMissingScopesList(missingScopes);

            {/* HANDLE SETTING CURRENT EVENT */}
            switch (recentValue) {
                case 'all':
                    setCurrList([...eventsArr, ...meetingsArr]);
                    setTotalPages(Math.ceil([...eventsArr, ...meetingsArr].length / ITEMS));
                    break;
                case 'meetings':
                    setCurrList(meetingsArr);
                    setTotalPages(Math.ceil(meetingsArr.length / ITEMS));
                    break;
                case 'events':
                    setCurrList(eventsArr);
                    setTotalPages(Math.ceil(eventsArr.length / ITEMS));
                    break;
            }
        };
        getRecents();
    }, [currentWorkspaces]);

    return (
        <Box>
            <Card
                raised
                sx={{
                    height: "500px",
                    height: '100%',
                    width: '100%',
                    background: 'white',
                    borderRadius: '35px',
                    padding: '5px',
                    marginTop: '15px',
                }}
            >
                {/* TITLE */}
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        marginBottom: '10px',
                    }}
                >
                    <Typography variant="h3" sx={{ paddingLeft: '15px', paddingRight: '50px', color: "#3B57B8", fontWeight: "bold" }}>
                        Upcoming
                    </Typography>
                    <Tabs value={recentValue} onChange={handleChange}>
                        <Tab value="all" label="All" sx={{ textTransform: 'none', fontSize: '15px' }} />
                        <Tab value="meetings" label="Meetings" sx={{ textTransform: 'none', fontSize: '15px' }} />
                        <Tab value="events" label="Events" sx={{ textTransform: 'none', fontSize: '15px' }} />
                    </Tabs>
                </Box> 

                {/* UPCOMING CONTENT */}
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        p: "2rem"
                    }}
                >
                    <IconButton
                        disabled={currentIndex === 0 || currentPage === 1}
                        onClick={() => {
                            setCurrentIndex(currentIndex - 1);
                            setCurrentPage(currentPage - 1);
                        }}
                    >
                        <KeyboardArrowLeftIcon />
                    </IconButton>

                    {/* ALL */}
                    {currList.length > 0 && currList.slice(
                        (currentPage - 1) * ITEMS,
                        currentPage * ITEMS
                    )?.map((meeting) => (
                        <MeetingsCard 
                            key={meeting.title} 
                            event={meeting} 
                        />
                    ))}
                    {currList.length === 0 && (
                        <Typography variant="h4" fontWeight="bold" color="#3B57B8">You have nothing on your calendar! Enjoy the day!</Typography>
                    )}

                    <IconButton
                        disabled={currentIndex + ITEMS >= currList.length || currentPage === totalPages}
                        onClick={() => {
                            setCurrentIndex(currentIndex + 1);
                            setCurrentPage(currentPage + 1);
                        }}
                    >
                        <KeyboardArrowRightIcon />
                    </IconButton>
                </Box>

                {/* PAGINATION */}
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Pagination
                        count={totalPages}
                        color="primary"
                        siblingCount={0}
                        page={currentPage}
                        onChange={(event, page) => setCurrentPage(page)}
                    />
                </Box>
            </Card>
        </Box>
    )
};

export default UpcomingItemsComponent;